// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"333772e1","952":"19b1e939"}[chunkId] + ".chunk.js";
};